import { fetchData } from "./index";
import { IFeedInfo } from "./interfaces";

export class MediumApi {
  async getFeedInfoByUser() {
    const apiUrl = `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@dm_hapi`;
    return fetchData<IFeedInfo>(apiUrl, {});
  }
}
